import { render, staticRenderFns } from "./BenefitDocumentPreview.vue?vue&type=template&id=251d1b36"
import script from "./BenefitDocumentPreview.vue?vue&type=script&lang=js"
export * from "./BenefitDocumentPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports